<template>
    <div v-if="candidates.length > 0">
        <div class="data-table-row row table-row" v-for="candidate in candidates" v-bind:key="candidate.candidateId">
            <div class="base-inline layout-50">
                <div>
                    <span>{{`${candidate.namePrefix} ${candidate.nameFirst} ${candidate.nameMiddle} ${candidate.nameLast}`}}</span>
                </div>
            </div>
            <div class="align-l base-inline layout-50">
                <div :class="getViewStatementStyling(candidate)">
                    <a tabindex="0" @keyup.enter="onViewStatementClickedHandler(candidate)" @click="onViewStatementClickedHandler(candidate)">{{ $t("LabelViewStatement") }}</a>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        There are no candidates for this contest.
    </div>
</template>

<script>
import { FETCH_PUBLISHEDCANDIDATESTATEMENT, SET_CONTEST_USING_SELECTED_CANDIDATE } from '../store/actions.type';
import { ASSETS } from '@/assets/js/assets.js'

export default {
    props: {
        candidates: Array,
        contestId: Number
    },
    computed: {
      
    },
    methods: {
        async onViewStatementClickedHandler(candidate) {
            const language =  ASSETS.LanguageSelection.GetCurrentLanguageAbbreviated();
            const payload = {
                contestId: this.contestId,
                candidateId: candidate.candidateId,
                candidateName:  `${candidate.namePrefix} ${candidate.nameFirst} ${candidate.nameMiddle} ${candidate.nameLast}`,
                selectedCandidate: candidate,
                selectedLanguage: language
            }
            await this.$store.dispatch(FETCH_PUBLISHEDCANDIDATESTATEMENT, payload);
            await this.$store.dispatch(SET_CONTEST_USING_SELECTED_CANDIDATE, candidate);
            this.$router.push({name: 'PublicStatement', params: {contestId: payload.contestId, candidateId: payload.candidateId, language}});
        },
          getViewStatementStyling(candidate) {
            if (candidate.publishedStatements ===  undefined) return "btn-blue-disabled";
            const ps = candidate.publishedStatements.find(ps => ps.language ===  ASSETS.LanguageSelection.GetCurrentLanguageAbbreviated());
            return ps !== undefined ? "btn-blue" : "btn-blue-disabled"
        }
    }
}
</script>

<style scoped>
.table-row {
    display: flex;
}
</style>